export default __webpack_public_path__ + "static/agro-header-f20964b0b711f01a233767be8b753936.svg";